import { createApp } from 'vue'
import Buefy from 'buefy'
import { createI18n } from 'vue-i18n'
import  VueGoogleMaps from '@fawmi/vue-google-maps'
import { GOOGLE_MAPS_KEY } from './constants';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import { auth } from './firebaseConfig';
import { languages, defaultLocale } from './locales/index';
import ClientStorageService from './services/client-storage-services';
import 'buefy/dist/css/buefy.css';
import '@/styles/overrides.scss';

document.title = 'Keelung For A Walk 雨都漫步 - Living Museum & Games';
//Vue.config.productionTip = false;

const storedLocale = ClientStorageService.getLanguageCode()
const messages = Object.assign(languages);
const i18n = createI18n({
  locale: storedLocale || defaultLocale,
  fallbackLocale: defaultLocale,
  messages,
});


router.beforeEach((to) => {
  const lang = to.params.lang;
  const newLocale = Array.isArray(lang) ? lang[0] : lang;

  if (languages.hasOwnProperty(newLocale) && i18n.global.locale !== newLocale) {
    i18n.global.locale = newLocale;
    ClientStorageService.setLanguageCode(newLocale);
  }
})


let app: ReturnType<typeof createApp> | null = null

auth.onAuthStateChanged(() => {
  if (!app) {
    app = createApp(App)

    app.use(router)
    app.use(store)
    app.use(i18n)
    app.use(Buefy)

    const HUNT_LANG_TO_MAPS: Record<string, string> = { zh: 'zh-TW', en: 'en', jp: 'ja' };
    const storedMapsLang = ClientStorageService.getMapsLanguage() || 'en';
    const mapsLanguage = HUNT_LANG_TO_MAPS[storedMapsLang] ?? 'en';

    app.use(VueGoogleMaps, {
      load: {
        key: GOOGLE_MAPS_KEY,
        language: mapsLanguage,
      },
    })

    app.mount('#app')
  }
})

// Make this configurable to enable dark mode
document.documentElement.setAttribute('data-theme', 'light')
